import { render, staticRenderFns } from "./priceListReport.vue?vue&type=template&id=3ffe24d8&"
import script from "./priceListReport.vue?vue&type=script&lang=js&"
export * from "./priceListReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports